import customFileField from '../util/customFileField'

const emptyValidator = el => el.value
const fileValidator = el => Array.from(el.files).length > 0
const checkboxValidator = el => el.checked

class FormHandler {
  constructor(selector) {
    this.form = selector;
    this.reqFields = Array.from(selector.querySelectorAll('.js-form-required'));
    this.reqFields.forEach(rf => {
      rf.required = false
    });
    customFileField(selector);
    this.attachEvents();
  }

  attachEvents() {
    this.form.addEventListener('submit', ev => {
      ev.preventDefault();
      if (this.validateForm()) {
        ev.target.submit()
      } else {
        $([document.documentElement, document.body]).animate({
          scrollTop: $(this.form).offset().top,
        }, 500);
      }
    })
  }

  validateForm() {
    let completed = 0

    this.reqFields.forEach(rf => {
      if (this.validate(rf)) {
        completed += 1
      }
    })

    return completed === this.reqFields.length
  }

  validate(rf) {
    let validated;
    const $parent = $(rf).parent();

    switch (rf.type) {
      case 'text':
        validated = emptyValidator(rf);

        if (validated) {
          $parent.removeClass('has-error');
        } else {
          $parent.addClass('has-error');
        }
        break;
      case 'email':
        validated = emptyValidator(rf);

        if (validated) {
          $parent.removeClass('has-error');
        } else {
          $parent.addClass('has-error');
        }
        break;
      case 'textarea':
        validated = emptyValidator(rf);

        if (validated) {
          $parent.removeClass('has-error');
        } else {
          $parent.addClass('has-error');
        }
        break;
      case 'file':
        validated = fileValidator(rf);

        if (validated) {
          $parent.parent().removeClass('has-error');
        } else {
          $parent.parent().addClass('has-error');
        }
        break;
      case 'checkbox':
        validated = checkboxValidator(rf);

        if (validated) {
          $parent.parent().removeClass('has-error');
        } else {
          $parent.parent().addClass('has-error');
        }
        break;
    }

    return validated;
  }
}

export default () => {
  const selector = document.querySelector('.js-form');

  if (!selector) return;
  const fh = new FormHandler(selector);
  
  return fh;
}


// WEBPACK FOOTER //
// ./scripts/modules/form.js